import { render } from "./portrait_play.vue?vue&type=template&id=fb3b34f2&scoped=true"
import script from "./portrait_play.vue?vue&type=script&lang=js"
export * from "./portrait_play.vue?vue&type=script&lang=js"

import "./portrait_play.vue?vue&type=style&index=0&id=fb3b34f2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb3b34f2"]])

export default __exports__